import { cn } from '../lib/cn'

export interface ProgressBarProps {
  value: number // 0–1
  className?: string
  label?: string
}

export function ProgressBar({ value, className, label }: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, Math.round(value * 100)))

  return (
    <div
      className={cn('w-full', className)}
      role="progressbar"
      tabIndex={0}
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div className="h-2 w-full rounded-full bg-cream-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-terracotta-400 transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
